import React from 'react';
import { EnterpriseUserTable } from '..';

const EnterpriseUser = (props) => {
  return <EnterpriseUserTable {...props} />;
};

export default EnterpriseUser;
